import { axios } from '@ben/api/axios';

interface ApprovalFlow {
  id: number;
  name: string;
  [key: string]: unknown;
}

interface ApprovalFlowsResponse {
  results: ApprovalFlow[];
  [key: string]: unknown;
}

export const getApprovalFlows = async (
  employerId: number,
  searchKey?: string
): Promise<ApprovalFlowsResponse> => {
  const response = await axios.get<ApprovalFlowsResponse>(
    `employers/${employerId}/approval-flows/?search=${searchKey ?? ''}`
  );
  return response.data;
};
